/**
 * Animations au scroll — Patouno
 * Ajoute la classe "in-view" aux éléments [data-animate] quand ils entrent dans le viewport.
 *
 * Robustesse :
 * - Le masquage initial n'est appliqué par le CSS que si <html> porte la classe
 *   "patouno-animate-enabled". Cette classe est ajoutée par un petit script inline dans
 *   le <head> (synchrone, avant peinture → pas de flash) UNIQUEMENT si JS est actif et que
 *   l'utilisateur n'a pas demandé "reduced motion". Sans JS, la classe n'existe pas et tout
 *   reste visible (opacity: 1).
 * - Si IntersectionObserver n'existe pas, on révèle tout immédiatement (fallback).
 */
(function () {
  var root = document.documentElement;

  // Si le masquage initial n'a pas été activé (no-JS impossible ici, mais reduced-motion oui),
  // il n'y a rien à animer : les éléments sont déjà visibles.
  if (!root.classList.contains('patouno-animate-enabled')) {
    return;
  }

  // Filet de sécurité : navigateurs sans IntersectionObserver → tout révéler.
  if (!('IntersectionObserver' in window)) {
    root.classList.remove('patouno-animate-enabled');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll() {
    var els = document.querySelectorAll('[data-animate]:not(.in-view)');
    for (var i = 0; i < els.length; i++) {
      observer.observe(els[i]);
    }
  }

  observeAll();

  // Ré-observe les sections rechargées dans l'éditeur de thème Shopify.
  document.addEventListener('shopify:section:load', observeAll);
})();
